const DEFAULT_SCROLL_VALUE = 0;

export { DEFAULT_SCROLL_VALUE };
